import React, { useState, useRef } from "react";
import "../Style/Pictures.css";
import { useLanguage } from "../Context/Languagecontext";

/* ─── Keys array to safely pull from dictionary maps ─── */
const TAB_IDS = ["all", "business", "hkn", "awards", "personal"];

/* ─── Image Data ────────────────────────────────────────── */
const IMAGES = {
  all: [
    { id: 1, src: require("../Assets/arun-kumar.jpg"), alt: "Moment 1" },
    { id: 2, src: require("../Assets/leader.jpeg"), alt: "Moment 2" },
    { id: 3, src: require("../Assets/pl13.jpeg"), alt: "Moment 3" },
    { id: 4, src: require("../Assets/hk9.jpg"), alt: "Moment 4" },
    { id: 5, src: require("../Assets/a11.JPG"), alt: "Moment 5" },
    { id: 6, src: require("../Assets/ak2.jpg"), alt: "Moment 6" },
    { id: 7, src: require("../Assets/arun-kumar7.jpeg"), alt: "Moment 7" },
    { id: 8, src: require("../Assets/hk10.jpg"), alt: "Moment 8" },
    // { id: 9, src: require("../Assets/pk4.png"), alt: "Moment 9" },
    { id: 10, src: require("../Assets/a15.JPG"), alt: "Moment 10" },
    { id: 11, src: require("../Assets/arun-kumar5.jpg"), alt: "Moment 11" },
    { id: 12, src: require("../Assets/hk33.jpg"), alt: "Moment 12" },
    // { id: 13, src: require("../Assets/pk9.png"), alt: "Moment 13" },
    // { id: 14, src: require("../Assets/pk17.png"), alt: "Moment 14" },
    { id: 15, src: require("../Assets/arun-kumar9.JPG"), alt: "Moment 15" },
    { id: 16, src: require("../Assets/hk32.jpg"), alt: "Moment 16" },
    { id: 17, src: require("../Assets/a12.JPG"), alt: "Moment 17" },
    // { id: 18, src: require("../Assets/pk51.jpg"), alt: "Moment 18" },
    { id: 19, src: require("../Assets/arun.jpeg"), alt: "Moment 19" },
    { id: 20, src: require("../Assets/s1 (1).jpeg"), alt: "Moment 20" },
    { id: 21, src: require("../Assets/p9.jpg"), alt: "Moment 21" },
    { id: 22, src: require("../Assets/hk1.jpg"), alt: "Moment 22" },
    { id: 23, src: require("../Assets/p3.jpg"), alt: "Moment 23" },
    { id: 24, src: require("../Assets/pk42.jpg"), alt: "Moment 24" },
    { id: 25, src: require("../Assets/Service6.jpg"), alt: "Moment 25" },
    { id: 26, src: require("../Assets/Service2.jpg"), alt: "Moment 26" },
    { id: 27, src: require("../Assets/pl3.jpg"), alt: "Moment 27" },
    { id: 28, src: require("../Assets/all.jpg"), alt: "Moment 28" },
    { id: 29, src: require("../Assets/all1.jpg"), alt: "Moment 29" },
    { id: 30, src: require("../Assets/all2.jpg"), alt: "Moment 30" },
    { id: 31, src: require("../Assets/all3.jpg"), alt: "Moment 31" },
    { id: 32, src: require("../Assets/all4.jpg"), alt: "Moment 32" },
    { id: 33, src: require("../Assets/all5.jpg"), alt: "Moment 33" },
    { id: 34, src: require("../Assets/all6.jpg"), alt: "Moment 34" },
    { id: 35, src: require("../Assets/all7.jpg"), alt: "Moment 35" },
    { id: 36, src: require("../Assets/all8.jpg"), alt: "Moment 36" },
    { id: 37, src: require("../Assets/all9.jpg"), alt: "Moment 37" },
    { id: 38, src: require("../Assets/all10.jpg"), alt: "Moment 38" },
    { id: 39, src: require("../Assets/all11.jpg"), alt: "Moment 39" },
    { id: 40, src: require("../Assets/all12.jpg"), alt: "Moment 40" },
    { id: 41, src: require("../Assets/all13.jpg"), alt: "Moment 41" },
    { id: 42, src: require("../Assets/all14.jpg"), alt: "Moment 42" },
    { id: 43, src: require("../Assets/all15.jpg"), alt: "Moment 43" },
    { id: 44, src: require("../Assets/all16.jpg"), alt: "Moment 44" },
    { id: 45, src: require("../Assets/all17.jpg"), alt: "Moment 45" },
    { id: 46, src: require("../Assets/Service4.jpg"), alt: "Moment 46" },
    // { id: 47, src: require("../Assets/pk18.png"), alt: "Moment 47" },
    { id: 48, src: require("../Assets/p13.jpeg"), alt: "Moment 48" },
    { id: 49, src: require("../Assets/all19.jpg"), alt: "Moment 49" },
    { id: 50, src: require("../Assets/all18.jpg"), alt: "Moment 50" },
    { id: 51, src: require("../Assets/s1 (7).jpeg"), alt: "Moment 51" },
    { id: 52, src: require("../Assets/all20.jpg"), alt: "Moment 52" },
    { id: 53, src: require("../Assets/hk34.jpg"), alt: "Moment 53" },
    // { id: 54, src: require("../Assets/pk20.png"), alt: "Moment 54" },
    { id: 55, src: require("../Assets/hk36.jpg"), alt: "Moment 55" },
    { id: 56, src: require("../Assets/a5.png"), alt: "Moment 56" },
    { id: 57, src: require("../Assets/all21.jpg"), alt: "Moment 57" },
    { id: 58, src: require("../Assets/s1 (2).jpeg"), alt: "Moment 58" },
    { id: 59, src: require("../Assets/pk61.jpg"), alt: "Moment 59" },
    { id: 60, src: require("../Assets/pk49.jpg"), alt: "Moment 60" },
    { id: 61, src: require("../Assets/all24.jpg"), alt: "Moment 61" },
    { id: 62, src: require("../Assets/p5.jpg"), alt: "Moment 62" },
    { id: 63, src: require("../Assets/champ.jpg"), alt: "Moment 63" },
    // { id: 64, src: require("../Assets/pk10.png"), alt: "Moment 64" },
    { id: 65, src: require("../Assets/all25.webp"), alt: "Moment 65" },
    { id: 66, src: require("../Assets/Service3.jpg"), alt: "Moment 66" },
    { id: 67, src: require("../Assets/hk22.jpg"), alt: "Moment 67" },
    { id: 68, src: require("../Assets/p8.jpg"), alt: "Moment 68" },
    { id: 69, src: require("../Assets/s1 (5).jpeg"), alt: "Moment 69" },
    { id: 70, src: require("../Assets/pk51.jpg"), alt: "Moment 70" },
    { id: 71, src: require("../Assets/arun-kumar3.jpg"), alt: "Moment 71" },
    { id: 72, src: require("../Assets/hk3.jpg"), alt: "Moment 72" },
    { id: 73, src: require("../Assets/p4.jpg"), alt: "Moment 73" },
    { id: 74, src: require("../Assets/d1.webp"), alt: "Moment 74" },
    { id: 75, src: require("../Assets/all26.jpg"), alt: "Moment 75" },
    { id: 76, src: require("../Assets/all27.jpg"), alt: "Moment 76" },
    { id: 77, src: require("../Assets/all28.jpg"), alt: "Moment 77" },
    { id: 78, src: require("../Assets/all29.jpg"), alt: "Moment 78" },
    { id: 79, src: require("../Assets/all30.jpg"), alt: "Moment 79" },
    { id: 80, src: require("../Assets/all31.jpg"), alt: "Moment 80" },
    { id: 81, src: require("../Assets/hk7.jpg"), alt: "Moment 81" },
    { id: 82, src: require("../Assets/s1 (6).jpeg"), alt: "Moment 82" },
    // { id: 83, src: require("../Assets/pk24.png"), alt: "Moment 83" },
    { id: 84, src: require("../Assets/b1.webp"), alt: "Moment 84" },
    { id: 85, src: require("../Assets/all32.png"), alt: "Personal 85" },
    { id: 86, src: require("../Assets/all33.png"), alt: "Personal 86" },
    { id: 87, src: require("../Assets/pk45.jpg"), alt: "Personal 87" },
    { id: 88, src: require("../Assets/r14.jpg"), alt: "Personal 88" },
    { id: 89, src: require("../Assets/service5.webp"), alt: "Personal 89" },
    { id: 90, src: require("../Assets/r1.jpg"), alt: "Personal 90" },
  ],
  business: [
    { id: 1, src: require("../Assets/b1.webp"), alt: "Business 1" },
    { id: 2, src: require("../Assets/b2.webp"), alt: "Business 2" },
    { id: 3, src: require("../Assets/b3.webp"), alt: "Business 3" },
    { id: 4, src: require("../Assets/b4.webp"), alt: "Business 4" },
    { id: 5, src: require("../Assets/b5.webp"), alt: "Business 5" },
    { id: 6, src: require("../Assets/ak16.jpeg"), alt: "Business 6" },
    { id: 7, src: require("../Assets/ak17.jpg"), alt: "Business 7" },
    { id: 8, src: require("../Assets/pk38.jpg"), alt: "Business 8" },
    { id: 9, src: require("../Assets/pl14.JPG"), alt: "Business 9" },
    { id: 10, src: require("../Assets/a14.JPG"), alt: "Business 10" },
    { id: 11, src: require("../Assets/arun-kumar9.JPG"), alt: "Business 11" },
    { id: 12, src: require("../Assets/arun.jpeg"), alt: "Business 12" },
    { id: 13, src: require("../Assets/all19.jpg"), alt: "Business 13" },
    { id: 14, src: require("../Assets/all18.jpg"), alt: "Business 14" },
    { id: 15, src: require("../Assets/a4.png"), alt: "Business 15" },
    { id: 16, src: require("../Assets/a5.png"), alt: "Business 16" },
    { id: 17, src: require("../Assets/a6.png"), alt: "Business 17" },
    { id: 18, src: require("../Assets/a7.png"), alt: "Business 18" },
    { id: 19, src: require("../Assets/m (1).jpeg"), alt: "Business 19" },
    { id: 20, src: require("../Assets/m (2).jpeg"), alt: "Business 20" },
    { id: 21, src: require("../Assets/m (3).jpeg"), alt: "Business 21" },
    { id: 22, src: require("../Assets/m (4).jpeg"), alt: "Business 22" },
    { id: 23, src: require("../Assets/m (5).jpeg"), alt: "Business 23" },
    { id: 24, src: require("../Assets/m (6).jpeg"), alt: "Business 24" },
    { id: 25, src: require("../Assets/m (7).jpeg"), alt: "Business 25" },
    { id: 26, src: require("../Assets/m (8).jpeg"), alt: "Business 26" },
    { id: 27, src: require("../Assets/m (9).webp"), alt: "Business 27" },
    { id: 28, src: require("../Assets/m (10).webp"), alt: "Business 28" },
    { id: 29, src: require("../Assets/m (11).webp"), alt: "Business 29" },
    { id: 30, src: require("../Assets/m (12).webp"), alt: "Business 30" },
    { id: 31, src: require("../Assets/m (13).webp"), alt: "Business 31" },
    { id: 32, src: require("../Assets/m (14).webp"), alt: "Business 32" },
    { id: 33, src: require("../Assets/m (15).webp"), alt: "Business 33" },
    { id: 34, src: require("../Assets/m (16).webp"), alt: "Business 34" },
    { id: 35, src: require("../Assets/m (17).webp"), alt: "Business 35" },
    { id: 36, src: require("../Assets/m (18).webp"), alt: "Business 36" },
    { id: 37, src: require("../Assets/m (3).webp"), alt: "Business 37" },
    { id: 38, src: require("../Assets/m (4).webp"), alt: "Business 38" },
    { id: 39, src: require("../Assets/m (5).webp"), alt: "Business 39" },
    { id: 40, src: require("../Assets/m (6).webp"), alt: "Business 40" },
    { id: 41, src: require("../Assets/m (7).webp"), alt: "Business 41" },
    { id: 42, src: require("../Assets/m (19).webp"), alt: "Business 42" },
    { id: 43, src: require("../Assets/m (20).webp"), alt: "Business 43" },
    { id: 44, src: require("../Assets/m (21).webp"), alt: "Business 44" },
    { id: 45, src: require("../Assets/m (22).webp"), alt: "Business 45" },
    { id: 46, src: require("../Assets/m (23).webp"), alt: "Business 46" },
    { id: 47, src: require("../Assets/m (24).webp"), alt: "Business 47" },
    { id: 48, src: require("../Assets/m (25).webp"), alt: "Business 48" },
    { id: 49, src: require("../Assets/m (26).webp"), alt: "Business 49" },
    { id: 50, src: require("../Assets/m (27).webp"), alt: "Business 50" },
    { id: 51, src: require("../Assets/m (28).webp"), alt: "Business 51" },
    { id: 52, src: require("../Assets/m (36).webp"), alt: "Business 52" },
    { id: 53, src: require("../Assets/m (37).webp"), alt: "Business 53" },
    { id: 54, src: require("../Assets/m (38).webp"), alt: "Business 54" },
    { id: 55, src: require("../Assets/m (39).webp"), alt: "Business 55" },
    { id: 56, src: require("../Assets/m (40).webp"), alt: "Business 56" },
    { id: 57, src: require("../Assets/m (41).webp"), alt: "Business 57" },
    { id: 58, src: require("../Assets/m (42).webp"), alt: "Business 58" },
    { id: 59, src: require("../Assets/m (58).webp"), alt: "Business 59" },
    { id: 60, src: require("../Assets/m (44).webp"), alt: "Business 60" },
    { id: 61, src: require("../Assets/m (45).webp"), alt: "Business 61" },
    { id: 62, src: require("../Assets/m (47).webp"), alt: "Business 62" },
    { id: 63, src: require("../Assets/m (48).webp"), alt: "Business 63" },
    { id: 64, src: require("../Assets/m (49).webp"), alt: "Business 64" },
    { id: 65, src: require("../Assets/m (50).webp"), alt: "Business 65" },
    { id: 66, src: require("../Assets/m (51).JPG"), alt: "Business 66" },
    { id: 67, src: require("../Assets/m (52).JPG"), alt: "Business 67" },
    { id: 68, src: require("../Assets/m (53).JPG"), alt: "Business 68" },
    { id: 69, src: require("../Assets/m (54).JPG"), alt: "Business 69" },
    { id: 70, src: require("../Assets/m (55).jpg"), alt: "Business 70" },
    { id: 71, src: require("../Assets/m (56).webp"), alt: "Business 71" },
    { id: 72, src: require("../Assets/m (57).webp"), alt: "Business 72" },
  ],
  hkn: [
    { id: 1, src: require("../Assets/hk1.jpg"), alt: "HKN 1" },
    { id: 2, src: require("../Assets/r1.jpg"), alt: "HKN 2" },
    { id: 3, src: require("../Assets/r8.jpg"), alt: "HKN 3" },
    { id: 4, src: require("../Assets/r10.jpg"), alt: "HKN 4" },
    { id: 5, src: require("../Assets/r11.jpg"), alt: "HKN 5" },
    { id: 6, src: require("../Assets/r12.jpg"), alt: "HKN 6" },
    { id: 7, src: require("../Assets/r9.jpg"), alt: "HKN 7" },
    { id: 8, src: require("../Assets/r13.jpg"), alt: "HKN 8" },
    { id: 9, src: require("../Assets/r14.jpg"), alt: "HKN 9" },
    { id: 10, src: require("../Assets/r15.jpg"), alt: "HKN 10" },
    { id: 11, src: require("../Assets/r16.jpg"), alt: "HKN 11" },
    { id: 12, src: require("../Assets/r17.jpg"), alt: "HKN 12" },
    { id: 13, src: require("../Assets/r7.jpg"), alt: "HKN 13" },
    { id: 14, src: require("../Assets/r2.jpg"), alt: "HKN 14" },
    { id: 15, src: require("../Assets/r5.jpg"), alt: "HKN 15" },
    { id: 16, src: require("../Assets/r4.jpg"), alt: "HKN 16" },
    { id: 17, src: require("../Assets/r3.jpg"), alt: "HKN 17" },
    { id: 18, src: require("../Assets/r6.jpg"), alt: "HKN 18" },
    { id: 19, src: require("../Assets/hk2.jpg"), alt: "HKN 19" },
    { id: 20, src: require("../Assets/hk3.jpg"), alt: "HKN 20" },
    { id: 21, src: require("../Assets/hk4.jpg"), alt: "HKN 21" },
    { id: 22, src: require("../Assets/hk5.jpg"), alt: "HKN 22" },
    { id: 23, src: require("../Assets/hk6.jpg"), alt: "HKN 23" },
    { id: 24, src: require("../Assets/hk7.jpg"), alt: "HKN 24" },
    { id: 25, src: require("../Assets/hk20.jpg"), alt: "HKN 25" },
    { id: 26, src: require("../Assets/hk9.jpg"), alt: "HKN 26" },
    { id: 27, src: require("../Assets/hk10.jpg"), alt: "HKN 27" },
    { id: 28, src: require("../Assets/hk11.jpg"), alt: "HKN 28" },
    { id: 29, src: require("../Assets/hk12.jpg"), alt: "HKN 29" },
    { id: 30, src: require("../Assets/hk13.jpg"), alt: "HKN 30" },
    { id: 31, src: require("../Assets/hk14.jpg"), alt: "HKN 31" },
    { id: 32, src: require("../Assets/hk15.jpg"), alt: "HKN 32" },
    { id: 33, src: require("../Assets/hk16.jpg"), alt: "HKN 33" },
    { id: 34, src: require("../Assets/hk17.jpg"), alt: "HKN 34" },
    { id: 35, src: require("../Assets/hk19.jpg"), alt: "HKN 35" },
    { id: 36, src: require("../Assets/hk20.jpg"), alt: "HKN 36" },
    { id: 37, src: require("../Assets/hk21.jpg"), alt: "HKN 37" },
    { id: 38, src: require("../Assets/hk22.jpg"), alt: "HKN 38" },
    { id: 39, src: require("../Assets/hk23.jpg"), alt: "HKN 39" },
    { id: 40, src: require("../Assets/hk24.jpg"), alt: "HKN 40" },
    { id: 41, src: require("../Assets/hk25.jpg"), alt: "HKN 41" },
    { id: 42, src: require("../Assets/hk26.jpg"), alt: "HKN 42" },
    { id: 43, src: require("../Assets/hk27.jpg"), alt: "HKN 43" },
    { id: 44, src: require("../Assets/hk28.jpg"), alt: "HKN 44" },
    { id: 45, src: require("../Assets/hk29.jpg"), alt: "HKN 45" },
    { id: 46, src: require("../Assets/hk30.jpg"), alt: "HKN 46" },
    { id: 47, src: require("../Assets/hk31.jpg"), alt: "HKN 47" },
    { id: 48, src: require("../Assets/hk32.jpg"), alt: "HKN 48" },
    { id: 49, src: require("../Assets/hk34.jpg"), alt: "HKN 49" },
    { id: 50, src: require("../Assets/hk35.jpg"), alt: "HKN 50" },
    { id: 51, src: require("../Assets/hk36.jpg"), alt: "HKN 51" },
    { id: 52, src: require("../Assets/hk37.jpg"), alt: "HKN 52" },
    { id: 53, src: require("../Assets/hk38.jpg"), alt: "HKN 53" },
  ],
  awards: [
    { id: 1, src: require("../Assets/a1.png"), alt: "Award 1" },
    { id: 5, src: require("../Assets/a5.png"), alt: "Award 5" },
    { id: 3, src: require("../Assets/a3.png"), alt: "Award 3" },
    { id: 4, src: require("../Assets/a4.png"), alt: "Award 4" },
    { id: 2, src: require("../Assets/a2.png"), alt: "Award 2" },
    { id: 6, src: require("../Assets/a6.png"), alt: "Award 6" },
    { id: 7, src: require("../Assets/a7.png"), alt: "Award 7" },
    { id: 8, src: require("../Assets/a8.png"), alt: "Award 8" },
    { id: 9, src: require("../Assets/a9.jpg"), alt: "Award 9" },
    { id: 10, src: require("../Assets/a10.jpg"), alt: "Award 10" },
    { id: 11, src: require("../Assets/a11.JPG"), alt: "Award 11" },
    { id: 13, src: require("../Assets/a13.JPG"), alt: "Award 13" },
    { id: 14, src: require("../Assets/a14.JPG"), alt: "Award 14" },
    { id: 15, src: require("../Assets/a15.JPG"), alt: "Award 15" },
  ],
  // social: [
  //   { id: 1, src: require("../Assets/pk1.png"), alt: "Social 1" },
  //   { id: 2, src: require("../Assets/pk2.png"), alt: "Social 2" },
  //   { id: 3, src: require("../Assets/pk3.png"), alt: "Social 3" },
  //   { id: 4, src: require("../Assets/pk4.png"), alt: "Social 4" },
  //   { id: 5, src: require("../Assets/pk5.png"), alt: "Social 5" },
  //   { id: 6, src: require("../Assets/pk6.png"), alt: "Social 6" },
  //   { id: 7, src: require("../Assets/pk7.png"), alt: "Social 7" },
  //   { id: 9, src: require("../Assets/pk9.png"), alt: "Social 9" },
  //   { id: 10, src: require("../Assets/pk10.png"), alt: "Social 10" },
  //   { id: 11, src: require("../Assets/pk11.png"), alt: "Social 11" },
  //   { id: 12, src: require("../Assets/pk12.png"), alt: "Social 12" },
  //   { id: 13, src: require("../Assets/pk13.png"), alt: "Social 13" },
  //   { id: 14, src: require("../Assets/pk14.png"), alt: "Social 14" },
  //   { id: 15, src: require("../Assets/pk15.png"), alt: "Social 15" },
  //   { id: 16, src: require("../Assets/pk16.png"), alt: "Social 16" },
  //   { id: 17, src: require("../Assets/pk17.png"), alt: "Social 17" },
  //   { id: 18, src: require("../Assets/pk18.png"), alt: "Social 18" },
  //   { id: 19, src: require("../Assets/pk19.png"), alt: "Social 19" },
  //   { id: 20, src: require("../Assets/pk20.png"), alt: "Social 20" },
  //   { id: 21, src: require("../Assets/pk21.png"), alt: "Social 21" },
  //   { id: 23, src: require("../Assets/pk23.png"), alt: "Social 23" },
  //   { id: 24, src: require("../Assets/pk24.png"), alt: "Social 24" },
  //   { id: 25, src: require("../Assets/pk25.png"), alt: "Social 25" },
  //   { id: 26, src: require("../Assets/pk26.png"), alt: "Social 26" },
  //   { id: 27, src: require("../Assets/pk27.png"), alt: "Social 27" },
  //   { id: 28, src: require("../Assets/pk28.png"), alt: "Social 28" },
  //   { id: 29, src: require("../Assets/pk29.png"), alt: "Social 29" },
  //   { id: 30, src: require("../Assets/pk30.png"), alt: "Social 30" },
  //   { id: 31, src: require("../Assets/pk31.png"), alt: "Social 31" },
  //   { id: 32, src: require("../Assets/pk32.png"), alt: "Social 32" },
  //   { id: 33, src: require("../Assets/pk33.png"), alt: "Social 33" },
  //   { id: 34, src: require("../Assets/pk34.png"), alt: "Social 34" },
  //   { id: 37, src: require("../Assets/pk37.jpg"), alt: "Social 37" },
  //   { id: 38, src: require("../Assets/pk38.jpg"), alt: "Social 38" },
  //   { id: 39, src: require("../Assets/pk39.jpg"), alt: "Social 39" },
  //   { id: 40, src: require("../Assets/pk40.jpg"), alt: "Social 40" },
  //   { id: 42, src: require("../Assets/pk42.jpg"), alt: "Social 42" },
  //   { id: 43, src: require("../Assets/pk43.jpg"), alt: "Social 43" },
  //   { id: 44, src: require("../Assets/pk44.jpg"), alt: "Social 43" },
  //   // { id: 45, src: require("../Assets/pk45.jpg"), alt: "Social 45" },
  //   { id: 46, src: require("../Assets/pk46.jpg"), alt: "Social 46" },
  //   { id: 47, src: require("../Assets/pk47.jpg"), alt: "Social 47" },
  //   { id: 48, src: require("../Assets/pk48.jpg"), alt: "Social 48" },
  //   { id: 49, src: require("../Assets/pk49.jpg"), alt: "Social 49" },
  //   { id: 51, src: require("../Assets/pk51.jpg"), alt: "Social 51" },
  //   { id: 52, src: require("../Assets/pk52.jpg"), alt: "Social 52" },
  //   { id: 53, src: require("../Assets/pk53.jpg"), alt: "Social 53" },
  //   { id: 54, src: require("../Assets/pk54.jpg"), alt: "Social 54" },
  //   { id: 55, src: require("../Assets/pk55.jpg"), alt: "Social 55" },
  //   { id: 57, src: require("../Assets/pk57.jpg"), alt: "Social 57" },
  //   { id: 58, src: require("../Assets/pk58.jpg"), alt: "Social 58" },
  //   { id: 59, src: require("../Assets/pk59.jpg"), alt: "Social 59" },
  //   { id: 60, src: require("../Assets/pk60.jpg"), alt: "Social 60" },
  //   { id: 61, src: require("../Assets/s1 (1).jpeg"), alt: "Social 61" },
  //   { id: 62, src: require("../Assets/s1 (2).jpeg"), alt: "Social 62" },
  //   { id: 63, src: require("../Assets/s1 (3).jpeg"), alt: "Social 63" },
  //   { id: 64, src: require("../Assets/s1 (4).jpeg"), alt: "Social 64" },
  //   { id: 65, src: require("../Assets/s1 (5).jpeg"), alt: "Social 65" },
  //   { id: 66, src: require("../Assets/s1 (6).jpeg"), alt: "Social 66" },
  //   { id: 67, src: require("../Assets/s1 (7).jpeg"), alt: "Social 67" },
  //   { id: 68, src: require("../Assets/social101 (1).webp"), alt: "Social 68" },
  //   { id: 69, src: require("../Assets/social101 (2).webp"), alt: "Social 69" },
  //   { id: 70, src: require("../Assets/social101 (3).webp"), alt: "Social 70" },
  //   { id: 71, src: require("../Assets/social101 (4).webp"), alt: "Social 71" },
  //   { id: 72, src: require("../Assets/social101 (5).webp"), alt: "Social 72" },
  //   { id: 73, src: require("../Assets/social101 (6).webp"), alt: "Social 73" },
  //   { id: 74, src: require("../Assets/social101 (7).webp"), alt: "Social 74" },
  //   { id: 75, src: require("../Assets/social101 (8).webp"), alt: "Social 75" },
  //   { id: 76, src: require("../Assets/social101 (9).webp"), alt: "Social 76" },
  //   { id: 77, src: require("../Assets/social101 (10).webp"), alt: "Social 77" },
  //   { id: 78, src: require("../Assets/social101 (11).webp"), alt: "Social 78" },
  //   { id: 79, src: require("../Assets/social101 (12).webp"), alt: "Social 79" },
  //   { id: 80, src: require("../Assets/social101 (13).webp"), alt: "Social 80" },
  //   { id: 81, src: require("../Assets/social101 (14).webp"), alt: "Social 81" },
  //   { id: 82, src: require("../Assets/social101 (15).webp"), alt: "Social 82" },
  //   { id: 83, src: require("../Assets/social101 (16).webp"), alt: "Social 83" },
  //   { id: 84, src: require("../Assets/social101 (17).webp"), alt: "Social 84" },
  //   { id: 85, src: require("../Assets/social101 (18).webp"), alt: "Social 85" },
  //   { id: 86, src: require("../Assets/social101 (19).webp"), alt: "Social 86" },
  //   { id: 87, src: require("../Assets/social101 (20).webp"), alt: "Social 87" },
  //   { id: 88, src: require("../Assets/social101 (21).webp"), alt: "Social 88" },
  //   { id: 89, src: require("../Assets/social101 (22).webp"), alt: "Social 89" },
  //   { id: 90, src: require("../Assets/social101 (23).webp"), alt: "Social 90" },
  //   { id: 91, src: require("../Assets/social101 (24).webp"), alt: "Social 91" },
  //   { id: 92, src: require("../Assets/social101 (25).webp"), alt: "Social 92" },
  //   { id: 93, src: require("../Assets/social101 (26).webp"), alt: "Social 93" },
  //   { id: 94, src: require("../Assets/social101 (27).webp"), alt: "Social 94" },
  //   { id: 95, src: require("../Assets/social101 (28).webp"), alt: "Social 95" },
  //   { id: 96, src: require("../Assets/social101 (29).webp"), alt: "Social 96" },
  //   { id: 97, src: require("../Assets/social101 (30).webp"), alt: "Social 97" },
  //   { id: 98, src: require("../Assets/social101 (31).webp"), alt: "Social 98" },
  //   { id: 99, src: require("../Assets/social101 (32).webp"), alt: "Social 99" },
  //   {
  //     id: 100,
  //     src: require("../Assets/social101 (33).webp"),
  //     alt: "Social 100",
  //   },
  //   {
  //     id: 101,
  //     src: require("../Assets/social101 (34).webp"),
  //     alt: "Social 101",
  //   },
  //   {
  //     id: 102,
  //     src: require("../Assets/social101 (35).webp"),
  //     alt: "Social 102",
  //   },
  //   {
  //     id: 103,
  //     src: require("../Assets/social101 (36).webp"),
  //     alt: "Social 103",
  //   },
  //   {
  //     id: 104,
  //     src: require("../Assets/social101 (37).webp"),
  //     alt: "Social 104",
  //   },
  //   {
  //     id: 105,
  //     src: require("../Assets/social101 (38).webp"),
  //     alt: "Social 105",
  //   },
  //   {
  //     id: 106,
  //     src: require("../Assets/social101 (39).webp"),
  //     alt: "Social 106",
  //   },
  //   {
  //     id: 107,
  //     src: require("../Assets/social101 (40).webp"),
  //     alt: "Social 107",
  //   },
  //   {
  //     id: 108,
  //     src: require("../Assets/social101 (41).webp"),
  //     alt: "Social 108",
  //   },
  //   {
  //     id: 109,
  //     src: require("../Assets/social101 (42).webp"),
  //     alt: "Social 109",
  //   },
  //   {
  //     id: 110,
  //     src: require("../Assets/social101 (43).webp"),
  //     alt: "Social 110",
  //   },
  //   {
  //     id: 111,
  //     src: require("../Assets/social101 (44).webp"),
  //     alt: "Social 111",
  //   },
  //   {
  //     id: 112,
  //     src: require("../Assets/social101 (45).webp"),
  //     alt: "Social 112",
  //   },
  //   {
  //     id: 113,
  //     src: require("../Assets/social101 (46).webp"),
  //     alt: "Social 113",
  //   },
  //   {
  //     id: 114,
  //     src: require("../Assets/social101 (47).webp"),
  //     alt: "Social 114",
  //   },
  //   {
  //     id: 115,
  //     src: require("../Assets/social101 (48).webp"),
  //     alt: "Social 115",
  //   },
  //   {
  //     id: 116,
  //     src: require("../Assets/social101 (49).webp"),
  //     alt: "Social 116",
  //   },
  //   {
  //     id: 117,
  //     src: require("../Assets/social101 (50).webp"),
  //     alt: "Social 117",
  //   },
  //   {
  //     id: 118,
  //     src: require("../Assets/social101 (51).webp"),
  //     alt: "Social 118",
  //   },
  //   {
  //     id: 119,
  //     src: require("../Assets/social101 (52).webp"),
  //     alt: "Social 119",
  //   },
  //   {
  //     id: 120,
  //     src: require("../Assets/social101 (53).webp"),
  //     alt: "Social 120",
  //   },
  //   {
  //     id: 121,
  //     src: require("../Assets/social101 (54).webp"),
  //     alt: "Social 121",
  //   },
  //   {
  //     id: 122,
  //     src: require("../Assets/social101 (55).webp"),
  //     alt: "Social 122",
  //   },
  //   {
  //     id: 123,
  //     src: require("../Assets/social101 (56).webp"),
  //     alt: "Social 123",
  //   },
  //   {
  //     id: 124,
  //     src: require("../Assets/social101 (57).webp"),
  //     alt: "Social 124",
  //   },
  //   {
  //     id: 125,
  //     src: require("../Assets/social101 (58).webp"),
  //     alt: "Social 125",
  //   },
  //   {
  //     id: 126,
  //     src: require("../Assets/social101 (59).webp"),
  //     alt: "Social 126",
  //   },
  //   {
  //     id: 127,
  //     src: require("../Assets/social101 (60).webp"),
  //     alt: "Social 127",
  //   },
  //   {
  //     id: 128,
  //     src: require("../Assets/social101 (61).webp"),
  //     alt: "Social 128",
  //   },
  //   {
  //     id: 129,
  //     src: require("../Assets/social101 (62).webp"),
  //     alt: "Social 129",
  //   },
  //   {
  //     id: 130,
  //     src: require("../Assets/social101 (63).webp"),
  //     alt: "Social 130",
  //   },
  // ],
  personal: [
    { id: 1, src: require("../Assets/p1.jpg"), alt: "Personal 1" },
    { id: 2, src: require("../Assets/p2.jpg"), alt: "Personal 2" },
    { id: 3, src: require("../Assets/p3.jpg"), alt: "Personal 3" },
    { id: 4, src: require("../Assets/p4.jpg"), alt: "Personal 4" },
    { id: 5, src: require("../Assets/p5.jpg"), alt: "Personal 5" },
    { id: 6, src: require("../Assets/p6.jpg"), alt: "Personal 6" },
    { id: 7, src: require("../Assets/p7.jpg"), alt: "Personal 7" },
    { id: 8, src: require("../Assets/p8.jpg"), alt: "Personal 8" },
    { id: 9, src: require("../Assets/p9.jpg"), alt: "Personal 9" },
    { id: 10, src: require("../Assets/p10.jpg"), alt: "Personal 10" },
    { id: 11, src: require("../Assets/p11.jpeg"), alt: "Personal 11" },
    { id: 12, src: require("../Assets/p12.jpeg"), alt: "Personal 12" },
    { id: 13, src: require("../Assets/all32.png"), alt: "Personal 13" },
    { id: 14, src: require("../Assets/all33.png"), alt: "Personal 14" },
    { id: 15, src: require("../Assets/mp.jpeg"), alt: "Personal 15" },
    { id: 16, src: require("../Assets/mp1.jpeg"), alt: "Personal 16" },
    { id: 17, src: require("../Assets/mp2.jpeg"), alt: "Personal 17" },
    { id: 18, src: require("../Assets/m (29).webp"), alt: "Personal 18" },
    { id: 19, src: require("../Assets/m (30).webp"), alt: "Personal 19" },
    { id: 20, src: require("../Assets/m (31).webp"), alt: "Personal 20" },
    { id: 21, src: require("../Assets/m (32).webp"), alt: "Personal 21" },
    { id: 22, src: require("../Assets/m (33).webp"), alt: "Personal 22" },
    { id: 23, src: require("../Assets/m (34).webp"), alt: "Personal 23" },
    { id: 24, src: require("../Assets/m (35).webp"), alt: "Personal 24" },
  ],
};

const CARDS_PER_PAGE = 6;

/* ─── Lightbox ───────────────────────────────────────────── */
function Lightbox({ images, index, onClose, onPrev, onNext }) {
  if (index === null) return null;
  return (
    <div className="picture-lightbox-overlay" onClick={onClose}>
      <button
        className="picture-lightbox-close"
        onClick={onClose}
        aria-label="Close"
      >
        ✕
      </button>
      <button
        className="picture-lightbox-arrow picture-lightbox-arrow--left"
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        aria-label="Previous"
      >
        ‹
      </button>
      <div
        className="picture-lightbox-image-wrap"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={images[index].src}
          alt={images[index].alt}
          className="picture-lightbox-img"
        />
        <p className="picture-lightbox-counter">
          {index + 1} / {images.length}
        </p>
      </div>
      <button
        className="picture-lightbox-arrow picture-lightbox-arrow--right"
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        aria-label="Next"
      >
        ›
      </button>
    </div>
  );
}

/* ─── Main Component ─────────────────────────────────────── */
export default function Pictures() {
  const { t, lang } = useLanguage();
  const [activeTab, setActiveTab] = useState("all");
  const [page, setPage] = useState(0);
  const [animating, setAnimating] = useState(false);
  const [slideDir, setSlideDir] = useState("right");
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const localCopy = t.pictures || {};
  const tabSchema = localCopy.tabs || {};

  // Resolve runtime attributes for the selected node block
  const currentTabContent = tabSchema[activeTab] || {
    title: "",
    description: "",
  };

  const images = IMAGES[activeTab] || [];
  const totalPages = Math.ceil(images.length / CARDS_PER_PAGE);
  const pageImages = images.slice(
    page * CARDS_PER_PAGE,
    (page + 1) * CARDS_PER_PAGE,
  );

  /* ── tab switch ── */
  const handleTabChange = (id) => {
    if (id === activeTab) return;
    setAnimating(true);
    setTimeout(() => {
      setActiveTab(id);
      setPage(0);
      setAnimating(false);
    }, 280);
  };

  /* ── page navigation ── */
  const goPage = (dir) => {
    const next = page + dir;
    if (next < 0 || next >= totalPages) return;
    setSlideDir(dir > 0 ? "right" : "left");
    setAnimating(true);
    setTimeout(() => {
      setPage(next);
      setAnimating(false);
    }, 280);
  };

  /* ── lightbox ── */
  const openLightbox = (localIdx) =>
    setLightboxIndex(page * CARDS_PER_PAGE + localIdx);
  const closeLightbox = () => setLightboxIndex(null);
  const prevImage = () =>
    setLightboxIndex((i) => (i - 1 + images.length) % images.length);
  const nextImage = () => setLightboxIndex((i) => (i + 1) % images.length);

  const gridClass = `picture-grid${animating ? ` picture-grid--exit-${slideDir}` : ""}`;

  return (
    <section
      className={`picture-section${lang === "ta" ? " picture-section--tamil" : ""}`}
    >
      {/* ── Decorative top rule ── */}
      <div className="picture-rule" aria-hidden="true">
        <span className="picture-rule__line" />
        <span className="picture-rule__diamond">◆</span>
        <span className="picture-rule__line" />
      </div>

      {/* ── Header ── */}
      <div
        className={`picture-header${animating ? " picture-header--fade" : ""}`}
      >
        <p className="picture-eyebrow">{localCopy.eyebrow}</p>
        <h2 className="picture-title">
          {currentTabContent.title.split(" ").map((word, index) => (
            <span key={index}>{word}&nbsp;</span>
          ))}
        </h2>
      </div>

      {/* ── Tabs ── */}
      <div className="picture-tabs" role="tablist">
        {TAB_IDS.map((id) => {
          const tabLabel = tabSchema[id]?.label || id;
          return (
            <button
              key={id}
              role="tab"
              aria-selected={activeTab === id}
              className={`picture-tab${activeTab === id ? " picture-tab--active" : ""}`}
              onClick={() => handleTabChange(id)}
            >
              {tabLabel}
            </button>
          );
        })}
      </div>

      {/* ── Grid + Side Arrows ── */}
      <div className="picture-stage">
        {/* Left arrow */}
        <button
          className={`picture-nav picture-nav--left${page === 0 ? " picture-nav--hidden" : ""}`}
          onClick={() => goPage(-1)}
          aria-label="Previous page"
        >
          ‹
        </button>

        {/* 2×3 grid */}
        <div className={gridClass}>
          {pageImages.map((img, idx) => (
            <div
              key={img.id}
              className="picture-card"
              style={{ animationDelay: `${idx * 60}ms` }}
              onClick={() => openLightbox(idx)}
            >
              <div className="picture-card__inner">
                <img
                  src={img.src}
                  alt={img.alt}
                  className="picture-card__img"
                  loading="lazy"
                />
                <div className="picture-card__overlay" aria-hidden="true" />
              </div>
            </div>
          ))}
        </div>

        {/* Right arrow */}
        <button
          className={`picture-nav picture-nav--right${page >= totalPages - 1 ? " picture-nav--hidden" : ""}`}
          onClick={() => goPage(1)}
          aria-label="Next page"
        >
          ›
        </button>
      </div>

      {/* ── Dot indicators ── */}
      <div className="picture-dots" aria-label="Page indicators">
        {Array.from({ length: totalPages }).map((_, i) => (
          <button
            key={i}
            className={`picture-dot${i === page ? " picture-dot--active" : ""}`}
            onClick={() => {
              setSlideDir(i > page ? "right" : "left");
              setAnimating(true);
              setTimeout(() => {
                setPage(i);
                setAnimating(false);
              }, 280);
            }}
            aria-label={`Page ${i + 1}`}
          />
        ))}
      </div>

      {/* ── Description ── */}
      <div
        className={`picture-description${animating ? " picture-description--fade" : ""}`}
      >
        <div className="picture-description__inner">
          <span className="picture-description__ornament">✦</span>
          <p>{currentTabContent.description}</p>
          <span className="picture-description__ornament">✦</span>
        </div>
      </div>

      {/* ── Bottom rule ── */}
      <div className="picture-rule picture-rule--bottom" aria-hidden="true">
        <span className="picture-rule__line" />
        <span className="picture-rule__diamond">◆</span>
        <span className="picture-rule__line" />
      </div>

      {/* ── Lightbox ── */}
      <Lightbox
        images={images}
        index={lightboxIndex}
        onClose={closeLightbox}
        onPrev={prevImage}
        onNext={nextImage}
      />
    </section>
  );
}
